import React from "react";
import {Container} from "react-bootstrap";

import {useMakePageRequest} from '../../../Hooks/RequestHooks';
import {useEditContextNodeId, usePermission} from '../../../Hooks/PermissionHooks';
import {useChangeTool} from '../../../Hooks/RouteHooks';

import {useToolBuilderOverride} from "../../../Hooks/ToolBuilderHooks";
import {useClassNames} from "../../../Hooks/StyleHooks";
import {SurveyComponent} from "../../../Components/Pages/ConservationActions/SurveyComponent";

export const SurveyPage = props => {
    useToolBuilderOverride(props);

    const {className, ...childProps} = props;

    // TODO: remove this next line once we
    // support the ES9 Object ...rest operator
    // https://nitayneeman.com/posts/object-rest-and-spread-properties-in-ecmascript-2018/
    delete(childProps['className']);

    const classNames = useClassNames(className);
    const makePageRequest = useMakePageRequest();
    const hasPermission = usePermission();
    const editContextNodeId = useEditContextNodeId();
    const changeTool = useChangeTool();

    return <Container className={classNames}>
        <SurveyComponent
            {...childProps}
            MakePageRequest={makePageRequest}
            HasPermission={hasPermission}
            EditContextNodeId={editContextNodeId}
            ChangeTool={changeTool}
        />
    </Container>
};


